import AssetService from 'src/services/AssetService';
import {TransferEligibilityForm} from 'src/types/onboarding';
import {FormikContextType} from 'formik';
import {CURRENT_FOUR_YEAR_NOT_TRANSFERRING} from 'src/views/public/utils/utils';

export default async function onControlledSubmit(
  form: FormikContextType<TransferEligibilityForm>
): Promise<void> {
  const addressVerified = form.values.confirmedUnverifiedAddress || form.values.addressVerified;

  const currentFourYearAndNotTransferring = form.values.currentInstitution?.fourYearTransfer;

  if (currentFourYearAndNotTransferring === 'false') {
    window.sessionStorage.setItem(CURRENT_FOUR_YEAR_NOT_TRANSFERRING, 'true');
  }

  if (addressVerified) return form.submitForm();

  const suggestion = await AssetService.verifyAddress(form.values);

  if (suggestion && suggestion.addressVerified) {
    return form.submitForm();
  }

  console.log('SETTING:', suggestion);
  form.setFieldValue('_addressSuggestion', suggestion);
}
